import { useQuery } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';
import { Success } from 'src/app/utils/statusCode';

import { clientApi } from '../api/clientApi';
import { AdyenTransactionRefusedResponse } from '../types/clientTypes';

const fetchAdyenCancelation = async (emailParamAdyenCancelation?: string) => {
  if (emailParamAdyenCancelation) {
    const response = await clientApi.getAdyenTableCancelation(
      emailParamAdyenCancelation
    );

    if ((response as AdyenTransactionRefusedResponse).status === Success) {
      return (response as AdyenTransactionRefusedResponse).data;
    } else {
      OpenNotification(
        true,
        'Erro ao carregar as transações',
        'Ocorreu um erro  ao carregar as transações, por favor tente novamente mais tarde.'
      );
    }
  } else {
    return null;
  }
};

export default function useCancelationAdyen(email?: string) {
  return useQuery({
    queryKey: ['cancelationAdyen', email],
    queryFn: () => fetchAdyenCancelation(email),
    refetchOnWindowFocus: false,
  });
}
